module.exports = __webpack_public_path__ + "assets/img/Fotolia_165560563_XS.36fc8a4d.jpg";